module.exports = __webpack_public_path__ + "static/media/blog-5.0f95d82e.svg";